module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("twitter_grid", [["div",{"class":"twit-wrapper pad-lr pad-b"},[["div",{"class":"global-title text-color-2"},[["textNode",{"text":"My Twitter"}]]],["ul",{"id":"twits","class":"twits-list"}],["div",{"class":"view"}],["div",{"class":"clear"}]]]]);
fox.registerTemplate("twitter_list", [["li",{},[["span",{"class":"name"},[["a",{"href":"","target":"_blank","rel":"nofollow"},[["span",{},[],[["authorName","__text",true]]]],[["connectId.pageUrl","href",true]]],["textNode",{"text":": "}]]],["textNode",{"text":" "}],["span",{},[["span",{},[],[["postText","__text",true,[{"name":"html","params":[]},{"name":"nofollow","params":[]}]]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/social/twitter.tpl
// module id = 1265
// module chunks = 4